<template>
  <div>
    <div id="popupBackground">
      <div @click="onDialogClose" id="triggerClick" aria-hidden="true"></div>
      <vx-card
        ref="dialog"
        role="dialog"
        aria-modal="true"
        :aria-label="title || 'Dialog'"
        id="genericPopup"
        class="flex"
        :fixed-height="true"
      >
        <div tabindex="0" data-focus-sentinel @focus="focusLastInDialog"></div>
        <div class="flex flex-col h-full">
          <div class="flex-none flex justify-between">
            <div>
              <heading v-if="title" size="h1" style-size="h4">{{ title }}</heading>
            </div>
            <vs-button
              :aria-label="title ? `Close ${title}` : 'Close dialog'"
              size="large"
              type="flat"
              icon="close"
              @click="onDialogClose"
            />
          </div>
          <div class="overflow-y-auto flex-auto">
            <slot></slot>
          </div>
        </div>
        <div tabindex="0" data-focus-sentinel @focus="focusFirstInDialog"></div>
      </vx-card>
    </div>
  </div>
</template>
<script>
import dialogMixin from '@/mixins/dialog';

export default {
  mixins: [dialogMixin],
  props: ['title'],
  methods: {
    onDialogClose() {
      this.$emit('close');
    },
  },
};
</script>
<style scoped>
#genericPopup {
  position: fixed;
  top: 10%;
  width: 60%;
  max-height: 80%;
  left: 20%;
}
video {
  width: 100%;
  height: auto;
}
#popupBackground {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99999;
}
#popupBackground #triggerClick {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
@media screen and (max-width: 768px) {
  #genericPopup {
    top: 10%;
    width: 94%;
    max-height: 80%;
    left: 3%;
  }
}
</style>
<style>
#genericPopup > div > .vx-card__body {
  height: 100% !important;
}
</style>
